/**
 * Feature flags — gates experimental or in-development features to specific users.
 * Add an email to DEV_EMAILS to grant access, remove it to hide the feature.
 */
const DEV_EMAILS = ['deanachelis@gmail.com', 'dean@sideoutiq.com'];

export const isDevUser = (email?: string | null): boolean => {
  if (!email) return false;
  return DEV_EMAILS.includes(email.toLowerCase().trim());
};
